import { cloneElement, ReactElement } from 'react';

import { Placeholder, PlaceholderProps } from '../../placeholders';

export type OverlayContentProps = Omit<PlaceholderProps, 'icon'> & {
  icon?: ReactElement<{ size?: number }>;
};

export const OverlayContent = ({
  icon,
  sx,
  testId = 'overlay-message',
  ...rest
}: OverlayContentProps) => {
  return (
    <Placeholder
      icon={icon ? cloneElement(icon, { size: 72 }) : undefined}
      titleProps={{ variant: 'h5' }}
      bodyProps={{ variant: 'P14R', component: 'div' }}
      stackProps={{
        // Not stopping propagation closes parent drawer
        onClick: (event) => event.stopPropagation(),
      }}
      sx={{
        width: 300,
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)',
        ...sx,
      }}
      testId={testId}
      {...rest}
    />
  );
};
